import React from 'react'
import {Box, Typography} from "@mui/material";
import {MAIN_COLOR_BLUE} from "../utils/styles";
import { useTranslation } from 'react-i18next';

const Subtitle = () =>{
    const {t} = useTranslation();
    return(
        <Box style={{textAlign:"center"}}>
            <Typography
                variant="body1"
                color={"gray"}
                fontWeight="bold"
                sx={{ mb: "5px" }}
            >
                {t('home_page.title' as any)}
            </Typography>
            <Typography variant="body2"    fontWeight="bold" color={MAIN_COLOR_BLUE}>
                {t('general.tum' as any)}
            </Typography>
        </Box>
    )
}
export default Subtitle
